import axios from 'axios';
import CredentialStorage from '~/api/credential-storage';

const credentialStorageInstance = (() => {
  const instance = new CredentialStorage(axios);
  return instance;
})();

export default credentialStorageInstance;
